export default __webpack_public_path__ + "static/media/info-primary.8cdc5fe8.svg";